import $ from './el.JsModules.js';

const SELECTOR = {
  BACK_IN_STOCK_BTN: '.js-back-in-stock',
  TITLE_EL: '.js-product-title',
  CLOSE_BTN: '.js-close-button',
  CLOSE_BTN: '.js-close-button',
  TEMPLATE: '.js-template',
};

const COMPANY_ID = 'XLNef5';

elabs.BackInStockPopover = class {
  'use strict';

  constructor(element) {
    this.inited = false;
    this.view = $(element);
    this.template = $(this.view.find(SELECTOR.TEMPLATE)[0].content);
  }

  show(payload) {
    if (!this.inited) {
      this.view.append(this.template);

      const form = this.view.find('form');

      form.on('submit', (e) => this.handleSubmit(e));

      window.addEventListener('CenteredPopoversWrapper:hide', () => {
        this.resetForm(form);
      });

      this.view.find(SELECTOR.CLOSE_BTN).on('click', () => window.CenteredPopovers['wrapper'].hide());
    }

    this.title = payload.title;
    this.view.find(SELECTOR.TITLE_EL).text(payload.title);
  }

  hide() {}

  async handleSubmit(e) {
    e.preventDefault();
    const emailInput = this.view.find('[type="email"]');
    const email = emailInput.val().trim();
    const { variantId } = $(SELECTOR.BACK_IN_STOCK_BTN).data();

    if (!elabs.Utils.validateEmail(email)) {
      emailInput.addClass('error');
      return;
    }

    emailInput.removeClass('error');

    try {
      const res = await this.subscribeInKlaviyo({
        email,
        variantId,
      });
      
      let data = null;
      // 202 = success with no body, 204 would behave the same
      if (res.status !== 202 && res.status !== 204) {
        // Only try to parse when we expect a body
        data = await res.json();
      }

      if (data?.errors?.length) {
        this.triggerToast({ success: false });
      } else {
        this.triggerToast({ success: true, email });
      }
    } catch (e) {
      this.triggerToast({
        success: false,
      });
      console.log('BackInStockPopover <handleSubmit> Error: ', { error: e });
    } finally {
      window.CenteredPopovers.wrapper.hide();
    }
  }

  async handleClick(e) {
    const { variantId, email } = e.target.dataset;

    try {
      const res = await this.subscribeInKlaviyo({
        email,
        variantId,
      });

      elabs.Utils.showToast(`We will alert you on ${email} if new stock arrives.`);
      console.log('BackInStockPopover <handleClick>', { res });
    } catch (e) {
      elabs.Utils.showToast(`There was a problem with subscribing:<br/> ${e.message}`);
      console.log('BackInStockPopover <handleClick> Error: ', { error: e });
    }
  }

  async subscribeInKlaviyo({ email, variantId }) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2023-12-15',
      },
      body: JSON.stringify(payload),
    };

    return await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${COMPANY_ID}`,
      requestOptions,
    );
  }

  triggerToast({ success, email = '' } = {}) {
    if (success) {
      elabs.Utils.showToast(`We will alert you on ${email} if new stock arrives.`, undefined, 9000);
      return;
    }

    elabs.Utils.showToast(
      'Creating a stock alert failed. Please try again, or contact customer services if the problem persists',
    );
  }

  resetForm(form) {
    $(form).find('input').val('').removeClass('error');
  }
};

// Initialise all Popovers
elabs.onJavascriptReady(() => {
  //Each popover must extend instance for global access !
  window.CenteredPopovers['back-in-stock'] = new elabs.BackInStockPopover('[data-centered-popover="back-in-stock"]');
});
